import React, {useEffect, useState} from 'react';
import ManageCoownership from '../coownership/ManageCoownership';
import ListOwner from '../members/ListOwner';
import ListProviders from '../providers/ListProviders';
import ListClaims from '../claims/ListClaims';
import ListBillboard from '../billboard/ListBillboard';
import ListTenant from '../members/ListTenant';
import { isAdmin, isCoownership, isProvider, isRentalManager, useUser } from '../contexts/UserContext';
import ListCoownerships from '../coownership/ListCoownerships';
import ListUsersProvider from '../members/ListUsersProvider';
import ListEvents from '../events/ListEvents';
import CalendarEvents from '../events/CalendarEvents';
import ListSurveys from '../surveys/ListSurveys';
import { useLocation } from 'react-router-dom';
import { PdfQA } from '../ai/PdfQA';
import Notes from '../notes/Notes';

const Dashboard = ({ initialMenu }) => {

  //contexte de l'utilisateur connecté
  const user = useUser();

    // Récupérer les états de navigation (pour la redirection avec paramètres)
    const location = useLocation();
    const navigationState = location.state;
  
  const [menu, setMenu] = useState(initialMenu || 
    (navigationState && navigationState.initialMenu) || 
    "residence"); 
  const [menuOpen, setMenuOpen] = useState(false);
  const [openClaims, setOpenClaims] = useState(false);
  const [openEvents, setOpenEvents] = useState(false);
  const [selectedDateCalendar, setSelectedDateCalendar] = useState(null);

  // Effet pour mettre à jour le menu si l'état de navigation change
  useEffect(() => {
    if (navigationState && navigationState.initialMenu) {
      setMenu(navigationState.initialMenu);
    }
  }, [navigationState]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const renderSwitchMenu = () => {
    switch(menu){
      case "residence": 
        return (
          <ManageCoownership />
        );
      case "prestataires": 
        return (
          <ListProviders />
        ); 
      case "coproprietaires": 
        return (
          <ListOwner />
        ); 
      case "locataires": 
        return(
          <ListTenant />
        ); 
      case "prestatairesInscrits": 
        return(
          <ListUsersProvider />
        ); 
      case "affichages": 
        return (
          <ListBillboard />
        ); 
      case "reclamations": 
        return (
          <ListClaims />
        ); 
      case "evenements": 
        return (
          <ListEvents onSelectDate={setSelectedDateCalendar} setMenu={setMenu}/>
        ); 
      case "calendrier": 
        return (
          <CalendarEvents selectedDate={selectedDateCalendar}/>
        ); 
      case "sondages":
        return(
          <ListSurveys />
        );
      default: 
        return (
          <ManageCoownership />
        );
    }
  }

  const renderSwitchMenuAdmin = () => {
    switch(menu){
      case "coproprietes": 
        return (
          <ListCoownerships />
        );
      case "ai": 
        return (
          <PdfQA />
        );
      default: 
        return (
          <ListCoownerships />
        );
    }
  }

  const renderSwitchMenuProvider = () => {
    switch(menu){
      case "affichages": 
        return (
          <ListBillboard />
        ); 
      case "evenements": 
        return (
          <ListEvents onSelectDate={setSelectedDateCalendar} setMenu={setMenu}/>
        ); 
      case "calendrier": 
        return (
          <CalendarEvents selectedDate={selectedDateCalendar}/>
        ); 
      case "sondages":
        return(
          <ListSurveys />
        );
      case "notes":
        return(
          <Notes />
        );
      case "reclamations":
        return (
          <ListClaims />
        );
      default: 
        return (
          <ListBillboard />
        ); 
    }
  }

  return (
    <div className='md:h-screen flex justify-center items-center bg-gray-100'>
      {isCoownership(user.user) ? (
        <div className='w-full flex flex-col md:flex-row md:w-5/6 md:h-5/6 bg-white p-8 rounded-lg shadow-md'>
          {/* Menu latéral */}
  
          <div className="md:hidden mb-4">
            <button className="text-primary font-bold" onClick={toggleMenu}>
              {menuOpen ? "Fermer Menu" : "Ouvrir Menu"}
            </button>
          </div>

          <aside className={`w-full md:w-1/6 bg-primary p-2 md:rounded-l-lg shadow-md ${menuOpen ? 'block' : 'hidden'} md:block`}>
            <h1 className='text-md text-black font-bold'>{user.user.userData.nameCoownershipLoaded}</h1>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("residence")}>Gestion résidence</li>
            </ul>
            <h2 className='text-black text-md font-bold mt-3'>Gestion des utilisateurs</h2>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("prestatairesInscrits")}>Prestataires</li>
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("coproprietaires")}>Copropriétaires</li>
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("locataires")}>Locataires</li>
            </ul>
            <h2 className='text-black text-md font-bold mt-3'>Gestion des fonctionnalités</h2>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("affichages")}>Affichages</li>
              <li className="text-white hover:text-secondary cursor-pointer flex items-center justify-between" onClick={() => setOpenClaims(!openClaims)}>
                <span>Demandes</span>
                <span>{openClaims ? '▲' : '▼'}</span>
              </li>
              {openClaims && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("prestataires")}>Gestion des prestataires</li>
              )}
              {openClaims && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("reclamations")}>Suivi des demandes</li>
              )}
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("sondages")}>Sondages</li>
              <li className="text-white hover:text-secondary cursor-pointer flex items-center justify-between" onClick={() => setOpenEvents(!openEvents)}>
                <span>Événements</span>
                <span>{openEvents ? '▲' : '▼'}</span>
              </li>
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("calendrier")}>Calendrier numérique</li>
              )}
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("evenements")}>Suivi des événements</li>
              )}
              
            </ul>
          </aside>
  
          {/* Contenu principal */}
          <main className="w-full md:w-5/6 p-4 overflow-auto bg-white p-4 md:rounded-r-lg md:shadow-md md:border-gray md:border-y md:border-r">
            {renderSwitchMenu()}
          </main>
        </div>
      ) : null }

      {isRentalManager(user.user) ? (
        <div className='w-full flex flex-col md:flex-row md:w-5/6 md:h-5/6 bg-white p-8 rounded-lg shadow-md'>
          {/* Menu latéral */}
  
          <div className="md:hidden mb-4">
            <button className="text-primary font-bold" onClick={toggleMenu}>
              {menuOpen ? "Fermer Menu" : "Ouvrir Menu"}
            </button>
          </div>

          <aside className={`w-full md:w-1/6 bg-primary p-2 md:rounded-l-lg shadow-md ${menuOpen ? 'block' : 'hidden'} md:block`}>
            <h1 className='text-md text-black font-bold'>{user.user.userData.nameCoownershipLoaded}</h1>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("residence")}>Gestion résidence</li>
            </ul>
            <h2 className='text-black text-md font-bold mt-3'>Gestion des utilisateurs</h2>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("locataires")}>Locataires</li>
            </ul>
            <h2 className='text-black text-md font-bold mt-3'>Gestion des fonctionnalités</h2>
            <ul className="space-y-1.5">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("affichages")}>Affichages</li>
              <li className="text-white hover:text-secondary cursor-pointer flex items-center justify-between" onClick={() => setOpenClaims(!openClaims)}>
                <span>Demandes</span>
                <span>{openClaims ? '▲' : '▼'}</span>
              </li>
              {openClaims && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("prestataires")}>Gestion des prestataires</li>
              )}
              {openClaims && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("reclamations")}>Suivi des demandes</li>
              )}
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("sondages")}>Sondages</li>
              <li className="text-white hover:text-secondary cursor-pointer flex items-center justify-between" onClick={() => setOpenEvents(!openEvents)}>
                <span>Événements</span>
                <span>{openEvents ? '▲' : '▼'}</span>
              </li>
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("calendrier")}>Calendrier numérique</li>
              )}
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("evenements")}>Suivi des événements</li>
              )}
              
            </ul>
          </aside>
  
          {/* Contenu principal */}
          <main className="w-full md:w-5/6 p-4 overflow-auto bg-white p-4 md:rounded-r-lg md:shadow-md md:border-gray md:border-y md:border-r">
            {renderSwitchMenu()}
          </main>
        </div>
      ) : null }

      {isAdmin(user.user) ? (
        <div className='w-full flex md:w-5/6 md:h-5/6 bg-white md:p-8 rounded-lg md:shadow-md'>
          {/* Menu latéral */}
  
          <aside className="hidden md:block w-1/6 bg-primary p-4 rounded-l-lg shadow-md">
            <h1 className="text-white text-2xl mb-4">Tableau de bord Administrateur</h1>
            <ul className="space-y-2">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("coproprietes")}>Copropriétés</li>
            </ul>
            <ul className="space-y-2">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("ai")}>Chat IA</li>
            </ul>
          </aside>
  
  
          {/* Contenu principal */}
          <main className="w-full md:w-5/6 p-4 overflow-auto bg-white p-4 rounded-r-lg shadow-md border-gray border-y border-r">
            {renderSwitchMenuAdmin()}
          </main>
        </div>
      ) : null }

      {isProvider(user.user) ? (
        <div className='w-full flex flex-col md:flex-row md:w-5/6 md:h-5/6 bg-white p-8 rounded-lg shadow-md'>
          {/* Menu latéral */}
  
          <div className="md:hidden mb-4">
            <button className="text-primary font-bold" onClick={toggleMenu}>
              {menuOpen ? "Fermer Menu" : "Ouvrir Menu"}
            </button>
          </div>

          <aside className={`w-full md:w-1/6 bg-primary p-4 md:rounded-l-lg shadow-md ${menuOpen ? 'block' : 'hidden'} md:block`}>
            <h1 className="text-white text-2xl mb-2">Tableau de bord Prestataire</h1>
            <h2 className='text-white text-lg mb-4 font-bold'>{user.user.userData.nameCoownershipLoaded}</h2>
            <ul className="space-y-2">
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("reclamations")}>Demandes</li>
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("affichages")}>Affichages</li>
              <li className="text-white hover:text-secondary cursor-pointer flex items-center justify-between" onClick={() => setOpenEvents(!openEvents)}>
                <span>Événements</span>
                <span>{openEvents ? '▲' : '▼'}</span>
              </li>
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("calendrier")}>Calendrier numérique</li>
              )}
              {openEvents && (
                <li className="text-white hover:text-secondary cursor-pointer ml-2 text-sm" onClick={() => setMenu("evenements")}>Suivi des événements</li>
              )}
              
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("sondages")}>Sondages</li>
              <li className="text-white hover:text-secondary cursor-pointer" onClick={() => setMenu("notes")}>Notes</li>
            </ul>
          </aside>
  
          {/* Contenu principal */}
          <main className="w-full md:w-5/6 p-4 overflow-auto bg-white p-4 md:rounded-r-lg md:shadow-md md:border-gray md:border-y md:border-r">
            {renderSwitchMenuProvider()}
          </main>
        </div>
      ) : null }

    </div>
  );
};

export default Dashboard;
